import pageheader from "../pageheader";
import { mapGetters } from "vuex";
import utils from "../../utils/util";
import moment from "moment";
import telematicsService from "../../api/telematics.service";
import EventBus from "../../utils/EventBus";
import XLSX from "xlsx";

const withLineItemNamesArray = (list) =>
  list.map((d) => {
    return {
      ...d,
      lineItemNamesArray: d.lineItemNames ? d.lineItemNames.split("|") : "",
    };
  });

// returns a fresh empty shape each call; the details dialog mutates it
const emptyResponseData = () => ({
  driverDelivery: {
    dateTime: "",
  },
  customerPickup: {
    dateTime: "",
  },
  driverPickup: {
    dateTime: "",
  },
});

export default {
  name: "contracts",
  components: { pageheader },
  data() {
    return {
      contractsDialogClass: "contracts-expanded",
      input: {},
      tempList: [],
      contractsList: [],
      pageNumber: 1,
      pageSize: 52,
      totalRecords: 0,
      totalRecordsCount: 0,
      isContractsLoading: false,
      nodata: false,
      yesdata: false,
      shownodata: false,
      search: "",
      options: {},
      statusList: ["Open", "Reservation", "Closed"],
      contractSearch: "",
      menu1: false,
      menu2: false,
      isDetailsLoading: false,
      responseData: emptyResponseData(),
      excelListContracts: [],
      excelHeaderContracts: [],
      startrowContracts: "",
      showtoggle: false,

      showDialog: false,
      showdriverPickup: true,
      showdriverdelivery: true,

      fromDate: "",
      toDate: "",
      status: "Open",
      sortBy: "",
      sortOrder: "",
      headers: [
        { text: "Contract#", value: "name", width: "12%" },
        { text: "Customer Name", value: "customerName" },
        { text: "Line Items", value: "lineItems", width: "30%" },
        { text: "Date Out", value: "initialContractDate" },
        { text: "Estimated Return Date", value: "endDateTime" },
        { text: "Status", value: "contractStatus" },
        { text: "Jobsite", value: "jobSite" },
        { text: "PO#", value: "customerPurchaseOrder" },

        { text: "Job Number", value: "customerJobNumber" },
        { text: "Ordered By", value: "orderedBy" },
        { text: "Picked Up by", value: "receivedBy" },
      ],
      toggle_exclusive_contracts: undefined,
      enableHeader: Boolean,
      countLables: [
        {
          name: "25",
          count: 25,
        },
        {
          name: "50",
          count: 50,
        },
        {
          name: "52",
          count: 52,
        },
        {
          name: "ALL",
          count: -1,
        },
      ],
      headers_Contacts: [
        { text: "Type", value: "type" },
        { text: "Name", value: "name" },
        { text: "Company Name", value: "companyName" },
      ],
      headers_LineItems: [
        { text: "Equipment #", value: "stockKey" },
        { text: "Equipment Name", value: "name" },
        { text: "Serial Number", value: "serialNumber" },
        { text: "Quantity", value: "quantity" },
      ],
      headers_Notes: [
        { text: "Type", value: "type" },
        { text: "Value", value: "value" },
      ],
      isExport: false,
    };
  },
  created() {
    this.toggle_exclusive_contracts = this.activeContractsToggleBtnVal;
    EventBus.$on("mini", this.onMiniChange);
  },
  computed: {
    ...mapGetters([
      "roles",
      "companyNameDropdown",
      "activeContractsToggleBtnVal",
    ]),
    startPageCount() {
      return this.pageNumber == -1
        ? 1
        : (this.pageNumber - 1) * this.pageSize + 1;
    },
    endPageCount() {
      return this.pageNumber == -1 || this.pageNumber == 1
        ? this.contractsList.length
        : (this.pageNumber - 1) * this.pageSize + this.contractsList.length;
    },
  },
  mounted() {
    // getting input content
    if (this.$route.query && this.$route.query.status) {
      this.status = String(this.$route.query.status);
    }
    this.input = utils.getInputContent("contracts", this.roles);

    if (this.$route.path == "/contracts") {
      this.enableHeader = true;
    } else {
      this.enableHeader = false;
    }
    if (this.$route.path == "/") {
      this.readContractsListFromApi();
    } else {
      this.readContractsListFromApi();
    }
  },
  beforeDestroy() {
    //clear the stored toggleBtn Val on page destroy
    this.$store.dispatch("setActiveContractsToggleVal", 0);
    EventBus.$off("mini", this.onMiniChange);
  },
  filters: {
    formatDates: function (value) {
      if (value) {
        const format = "MM/DD/YYYY";
        let date = value.split("T")[0];
        return moment(date).format(format);
      } else {
        let emptydata = "";
        return emptydata;
      }
    },
    formattoLocalDate: function (value) {
      if (value) {
        const format = "MM/DD/YYYY";
        return moment.utc(value).local().format(format);
      }
    },
  },
  methods: {
    onMiniChange(minivalue) {
      if (minivalue) {
        this.contractsDialogClass = "contracts-minimized";
      } else {
        this.contractsDialogClass = "contracts-expanded";
      }
    },
    sortByTable(val1) {
      if (val1 == undefined) {
        this.sortBy = "";
      } else {
        this.sortBy = val1;
      }
    },
    sortTableOrder(val) {
      if (val == undefined) {
        this.sortOrder = "";
      } else if (val == true) {
        this.sortOrder = "DESC";
      } else if (val == false) {
        this.sortOrder = "ASC";
      }
      this.readContractsListFromApi();
    },
    onToggleChange() {
      this.$store.dispatch(
        "setActiveContractsToggleVal",
        this.toggle_exclusive_contracts
      );
      this.readContractsListFromApi();
      this.contractsList.map((item) => {
        item.active = false;
        return item;
      });
    },
    statuschange() {
      if (this.status == "Closed") {
        this.headers = [
          { text: "Contract#", value: "name", width: "12%" },
          { text: "Customer Name", value: "customerName" },

          { text: "Line Items", value: "lineItems", width: "30%" },
          { text: "Date Out", value: "initialContractDate" },
          { text: "Billed To", value: "endDateTime" },
          { text: "Status", value: "contractStatus" },
          { text: "Jobsite", value: "jobSite" },
          { text: "PO#", value: "customerPurchaseOrder" },

          { text: "Job Number", value: "customerJobNumber" },

          { text: "Ordered By", value: "orderedBy" },
          { text: "Picked Up by", value: "receivedBy" },

          { text: "Actions", value: "action" },
        ];
      }
      if (this.status == "Open" || this.status == "Reservation") {
        this.headers = [
          { text: "Contract#", value: "name", width: "12%" },
          { text: "Customer Name", value: "customerName" },

          { text: "Line Items", value: "lineItems", width: "30%" },
          { text: "Date Out", value: "initialContractDate" },
          { text: "Estimated Return Date", value: "endDateTime" },
          { text: "Status", value: "contractStatus" },
          { text: "Jobsite", value: "jobSite" },
          { text: "PO#", value: "customerPurchaseOrder" },

          { text: "Job Number", value: "customerJobNumber" },

          { text: "Ordered By", value: "orderedBy" },
          { text: "Picked Up by", value: "receivedBy" },

          { text: "Actions", value: "action" },
        ];
      }
    },
    viewContractDetails(id) {
      this.showDialog = true;
      this.readContractDetailsFromId(id);
      this.contractsList.map((item) => {
        if (item.id == id) {
          item.active = true;
        } else {
          item.active = false;
        }
        return item;
      });
    },
    clearFilters() {
      this.fromDate = "";
      this.toDate = "";
      this.contractSearch = "";
      this.status = "Open";
      this.shownodata = false;
      if (this.$route.query && this.$route.query.status) {
        this.$router.replace({ query: null });
      } else {
        this.readContractsListFromApi();
      }
    },

    closeDialog() {
      this.nodata = false;
      this.yesdata = false;
      this.showDialog = false;
      this.responseData = emptyResponseData();
    },
    async readContractsListFromApi() {
      let status = "Open";
      if (this.$route.path == "/") {
        this.status = status;
      }
      this.isContractsLoading = true;
      this.contractsList = [];
      this.excelListContracts = [];
      try {
        let response = await telematicsService.getContractsList(
          this.fromDate,
          this.toDate,
          encodeURIComponent(this.contractSearch), // encoding special characters using encodeURIComponent
          this.status,
          this.pageNumber,
          this.pageSize,
          this.sortBy,
          this.sortOrder
        );
        if (response) {
          this.isContractsLoading = false;

          this.showtoggle = true;
          this.contractsList = response.data;
          this.contractsList = withLineItemNamesArray(this.contractsList);

          this.totalRecordsCount = response.totalRecords;
          let totalRecords = Math.ceil(this.totalRecordsCount / this.pageSize);
          if (this.pageSize == -1) {
            this.totalRecords = 1;
          } else {
            this.totalRecords = parseInt(totalRecords);
          }
          if (response.data.length == 0) {
            this.shownodata = true;
          } else {
            this.shownodata = false;
          }
        } else {
          this.isContractsLoading = false;
          this.showtoggle = true;

          this.contractsList = [];
        }
      } catch (err) {
        console.log(err);
        this.isContractsLoading = false;
        this.showtoggle = true;
      }
    },
    async readContractDetailsFromId(Id) {
      this.isDetailsLoading = true;
      try {
        let response = await telematicsService.getcontractsDataById(Id);
        if (response.isSuccess) {
          this.isDetailsLoading = false;
          this.yesdata = true;
          this.nodata = false;
          this.responseData = response.data;
          if (this.responseData.addresses[0].city) {
            this.responseData.singleaddress =
              this.responseData.addresses[0].city +
              ", " +
              this.responseData.addresses[0].line1 +
              " " +
              this.responseData.addresses[0].postalCode;
          } else {
            this.responseData.singleaddress = "";
          }
          this.responseData.customerPickup.address =
            this.responseData.customerPickup.address == null
              ? ""
              : this.responseData.customerPickup.address;
          this.responseData.driverDelivery.dateTime = this.responseData
            .driverDelivery.dateTime
            ? moment(
                this.responseData.driverDelivery.dateTime.split("T")[0]
              ).format("MM/DD/YYYY")
            : "";
          this.responseData.customerPickup.dateTime = this.responseData
            .customerPickup.dateTime
            ? moment(
                this.responseData.customerPickup.dateTime.split("T")[0]
              ).format("MM/DD/YYYY")
            : "";
          this.responseData.driverPickup.dateTime = this.responseData
            .driverPickup.dateTime
            ? moment(
                this.responseData.driverPickup.dateTime.split("T")[0]
              ).format("MM/DD/YYYY")
            : "";
          if (this.responseData.driverPickup.locationName == "") {
            this.showdriverPickup = false;
          } else {
            this.showdriverPickup = true;
          }
          if (this.responseData.customerPickup.locationName != "") {
            this.responseData.customerPickup.locationName =
              this.responseData.customerPickup.locationName.split("-")[1];
          }
          if (this.responseData.driverDelivery.locationName == "") {
            this.showdriverdelivery = false;
          } else {
            this.showdriverdelivery = true;
          }
        } else {
          this.isDetailsLoading = false;
          this.nodata = true;
          this.yesdata = false;

          this.responseData = emptyResponseData();
        }
      } catch (error) {
        this.isDetailsLoading = false;
        this.$toast.error("Unable to load the data" + error);
      }
    },
    async exportTableDataContracts() {
      this.isExport = true;
      this.excelListContracts = [];
      let pageNumber = 1;
      let pageSize = -1;
      try {
        let response = await telematicsService.getContractsList(
          this.fromDate,
          this.toDate,
          encodeURIComponent(this.contractSearch), // encoding special characters using encodeURIComponent
          this.status,
          pageNumber,
          pageSize
        );
        if (response) {
          if (response.data.length > 0) {
            this.isExport = false;
            let contractsList = response.data;
            contractsList = withLineItemNamesArray(contractsList);
            const formatDate = "MM/DD/YYYY";
            this.excelListContracts = contractsList.map((item) => {
              return {
                customerName: item.customerName ? item.customerName : "",
                contractId: item.id ? item.id + "-" + item.depotId : "",
                orderedBy: item.orderedBy ? item.orderedBy : "",
                receivedBy: item.receivedBy ? item.receivedBy : "",
                initialContractDate: item.initialContractDate
                  ? moment(item.initialContractDate.split("T")[0])
                      .local()
                      .format(formatDate)
                  : "",
                endDateTime: item.endDateTime
                  ? moment(item.endDateTime.split("T")[0])
                      .local()
                      .format(formatDate)
                  : "",
                contractStatus: item.contractStatus ? item.contractStatus : "",
                po: item.customerPurchaseOrder
                  ? item.customerPurchaseOrder
                  : "",
                jobSite: item.jobSite ? item.jobSite : "",
                lineItems: item.lineItems ? item.lineItems : "",

                customerJobNumber: item.customerJobNumber
                  ? item.customerJobNumber
                  : "",
              };
            });
            for (let r = 0; r < this.excelListContracts.length; r++) {
              if (this.excelListContracts[r].lineItems.length > 0) {
                for (
                  let d = 0;
                  d < this.excelListContracts[r].lineItems.length;
                  d++
                ) {
                  this.excelListContracts[r].lineItems[d][
                    "initialContractDate"
                  ] = this.excelListContracts[r].initialContractDate;
                  this.excelListContracts[r].lineItems[d]["endDateTime"] =
                    this.excelListContracts[r].endDateTime;
                  this.excelListContracts[r].lineItems[d]["contractId"] =
                    this.excelListContracts[r].contractId;
                  this.excelListContracts[r].lineItems[d]["orderedBy"] =
                    this.excelListContracts[r].orderedBy;
                  this.excelListContracts[r].lineItems[d]["receivedBy"] =
                    this.excelListContracts[r].receivedBy;
                  this.excelListContracts[r].lineItems[d]["po"] =
                    this.excelListContracts[r].po;
                  this.excelListContracts[r].lineItems[d]["contractStatus"] =
                    this.excelListContracts[r].contractStatus;
                  this.excelListContracts[r].lineItems[d]["customerJobNumber"] =
                    this.excelListContracts[r].customerJobNumber;
                  this.excelListContracts[r].lineItems[d]["customerName"] =
                    this.excelListContracts[r].customerName;
                  this.excelListContracts[r].lineItems[d]["jobSite"] =
                    this.excelListContracts[r].jobSite;
                }
              }
            }

            this.tempList = this.excelListContracts
              .map((e) => e.lineItems)
              .flat();
            this.excelHeaderContracts = [];
            this.startrowContracts = 3;
            this.excelHeaderContracts.push(["Contracts Data"]);
            this.startrowContracts += 1;
            let cust;
            if (this.companyNameDropdown == "") {
              cust = "All";
            } else {
              cust = this.$store.getters.companyNameDropdown;
            }
            this.excelHeaderContracts.push(["Customer:" + " " + cust]);
            if (this.fromDate) {
              this.startrowContracts += 1;
              this.excelHeaderContracts.push([
                "From Date:" + " " + this.fromDate,
              ]);
            }
            if (this.toDate) {
              this.startrowContracts += 1;
              this.excelHeaderContracts.push(["To Date:" + " " + this.toDate]);
            }
            if (this.contractSearch) {
              this.startrowContracts += 1;
              this.excelHeaderContracts.push([
                "Contract #/Job Name/PO #/Equipment Name/Equipment # :" +
                  " " +
                  this.contractSearch,
              ]);
            }
            if (this.status) {
              this.startrowContracts += 1;
              this.excelHeaderContracts.push(["Status :" + " " + this.status]);
            }
            this.excelHeaderContracts.push([]);
            this.startrowContracts += 1;
            if (this.status == "Closed") {
              this.excelHeaderContracts.push([
                "Contract#",
                "Customer Name",

                "Equipment #",
                "Equipment Name",
                "Quantity",
                "Date Out",
                "Billed To",
                "Status",
                "Item Status",

                "Jobsite",
                "PO#",
                "Job Number",

                "Ordered By",
                "Picked Up by",
              ]);
            }

            if (this.status == "Reservation" || this.status == "Open") {
              this.excelHeaderContracts.push([
                "Contract#",
                "Customer Name",
                "Equipment #",
                "Equipment Name",
                "Quantity",
                "Date Out",
                "Estimated Return Date",
                "Status",
                "Item Status",
                "Jobsite",
                "PO#",
                "Job Number",

                "Ordered By",
                "Picked Up by",
              ]);
            }
            let tempExcel = this.tempList.map((item) => {
              return {
                contractId: item.contractId,
                customerName: item.customerName,
                stockKey: item.stockKey,
                stockName: item.stockName,
                quantity: item.quantity,
                initialContractDate: item.initialContractDate,
                endDateTime: item.endDateTime,
                contractStatus: item.contractStatus,
                status: item.status,
                jobSite: item.jobSite,
                po: item.po,
                customerJobNumber: item.customerJobNumber,
                orderedBy: item.orderedBy,
                receivedBy: item.receivedBy,
              };
            });
            let datarow = "A" + this.startrowContracts;
            var ws = XLSX.utils.aoa_to_sheet(this.excelHeaderContracts);
            XLSX.utils.sheet_add_json(ws, tempExcel, {
              header: [
                "contractId",
                "customerName",

                "stockKey",
                "stockName",
                "quantity",
                "initialContractDate",
                "endDateTime",

                "contractStatus",
                "status",
                "jobSite",
                "po",
                "customerJobNumber",

                "orderedBy",
                "receivedBy",
              ],
              skipHeader: true,
              origin: datarow,
            });
            var wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Contracts Data");
            this.excelHeaderContracts = [];
            XLSX.writeFile(wb, "Contracts Data.xlsx");
          } else {
            this.isExport = false;
            this.$toast.error("Data not found");
          }
        } else {
          this.isExport = false;
          this.$toast.error("Unable to load the data");
        }
      } catch (err) {
        console.log(err);
        this.isExport = false;
      }
    },
    pageChange() {
      this.sortBy = "";
      this.sortOrder = "";
      this.readContractsListFromApi();
    },
    getFirstPageData() {
      this.pageNumber = 1;
      this.pageSize = 52;
      this.readContractsListFromApi();
    },
    getLastPageData() {
      this.pageNumber = this.totalRecords;
      this.pageSize = 52;
      this.readContractsListFromApi();
    },
    direction(item) {
      this.$router.push("/?contractkey=" + item.name);
    },
  },
};
